import axios from 'axios';
import { ElMessage,ElMessageBox } from 'element-plus'
require("babel-polyfill");
import { url } from './url';
import router from "../router";
import {setStorage,getStorage} from '@/utils/util'

var request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 1800000,  // 30分钟
});

// 添加响应拦截器
request.interceptors.response.use(
    response => response,
    error => {
        console.error('[Axios Error]', error);
        console.error('[Axios Error Response]', error.response);
        console.error('[Axios Error URL]', error.config?.url);
        
        // 静默处理type=4用户的权限错误
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        if (userInfo.type === 4 && error.response?.status === 403) {
            console.log('[Info] type=4用户权限限制，已静默处理');
            return Promise.reject(error);
        }
        
        return Promise.reject(error);
    }
);

// 统一错误处理函数
function handleError(error) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    if (userInfo.type !== 4) {
        ElMessage.error("请求失败");
    }
}

function ajax(opt,method){
  var token= getStorage('logintoken')
  var params;

  if(opt.params){
    //对传入的参数进行深拷贝，防止传入的参数对象被页面上其他逻辑改变，导致签名错误
    if (Object.prototype.toString.call(opt.params) != '[object FormData]') {
      // 不是formdata类型
      params = JSON.parse(JSON.stringify(opt.params));
    }else{//formdata类型
      params= opt.params
    }
    if(method=='GET'||method == 'DELETE1') {
      params={
        ...params,
      }
    }
  }else{
    params={}
  }

  if(method == 'PUT' || method == 'DELETE') {
      var config={
          url:  opt.url + params.id+'/',
          method: method,
          headers:{
              Authorization: 'JWT ' + token,
          }
      }
      if(!params.id){
          config={
          url: opt.url,
          method: method,
          headers:{
              Authorization: 'JWT ' + token,
          }
        }
      }

      method==="PUT"&&(config.params=params);
      return new Promise((resolve,reject)=>{
          request({
                url: config.url,
                method: method,
                headers:{
                    Authorization: 'JWT ' + token,
                },
                data: params
              }).then(res=>{
              if(res.data.code==4001){
                  ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                      confirmButtonText:'确定',
                      type: 'warning',
                      callback: action => {
                          //跳转登录页   callback点击确定按钮后的回调函数
                          localStorage.clear();
                          sessionStorage.clear();
                          window.location.href="/"
                      }
                  })
              }else{
                  resolve(res.data)
              }
          }).catch(res=>{
              handleError(res);
              reject(res)
          })
      })
  }else if(method == 'GET2'){
      var config2={
          url: opt.url + params.id+'/',
          method: 'GET',
          headers:{
              Authorization: 'JWT ' + token,
          }
      }
      if(!params.id){
          config2={
              url: opt.url,
              method: 'GET',
              headers:{
                  Authorization: 'JWT ' + token,
              }
          }
      }
      return new Promise((resolve,reject)=>{
          request({
              url: config2.url,
              method: 'GET',
              headers:{
                  Authorization: 'JWT ' + token,
              },
              data: params
          }).then(res=>{
              if(res.data.code==4001){
                  ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                      confirmButtonText:'确定',
                      type: 'warning',
                      callback: action => {
                          //跳转登录页   callback点击确定按钮后的回调函数
                          localStorage.clear();
                          sessionStorage.clear();
                          window.location.href="/"
                      }
                  })
              }else{
                  resolve(res.data)
              }
          }).catch(res=>{
              handleError(res);
              reject(res)
          })
      })
  }else if(method == 'DELETE1'){
    var config2={
        url: opt.url,
        method: 'DELETE',

        headers:{
            Authorization: 'JWT ' + token,
        }
    }
    
    return new Promise((resolve,reject)=>{
        request({
            url: config2.url,
            method: 'DELETE',
            headers:{
                Authorization: 'JWT ' + token,
            },
            params: params
        }).then(res=>{
            if(res.data.code==4001){
                ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                    confirmButtonText:'确定',
                    type: 'warning',
                    callback: action => {
                        //跳转登录页   callback点击确定按钮后的回调函数
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href="/"
                    }
                })
            }else{
                resolve(res.data)
            }
        }).catch(res=>{
            handleError(res);
            reject(res)
        })
    })
  }
  else {
      var config1={
          url: opt.url,
          method: method,
          headers:{
              Authorization: 'JWT ' + token,
          }
      }
      method==="GET"&&(config1.params=params);
      method==="POST"&&(config1.data=params);
      method==="PATCH"&&(config1.data=params);
      return new Promise((resolve,reject)=>{
          request(config1).then(res=>{
              if(res.data.code==4001){
                  ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                      confirmButtonText:'确定',
                      type: 'warning',
                      callback: action => {
                          //跳转登录页   callback点击确定按钮后的回调函数
                          localStorage.clear();
                          sessionStorage.clear();
                          window.location.href="/"
                      }
                  })
              }else{
                  resolve(res.data)
              }
          }).catch(res=>{
              handleError(res);
              reject(res)
          })
      })
  }
}



export function ajaxGet (opt) {
    return ajax(opt,"GET")
}
export function ajaxPut (opt) {
    return ajax(opt,"PUT")
}
export function ajaxDelete (opt) {
    return ajax(opt,"DELETE")
}
export function ajaxDelete1 (opt) {
    return ajax(opt,"DELETE1")
}
export function ajaxPost (opt) {
  return ajax(opt,"POST")
}
export function ajaxPost1 (opt, data) {
  return ajax(opt,"POST", data)
}
export function ajaxPatch (opt) {
  return ajax(opt,"PATCH")
}
// 单例详情获取get /api/test/12xxxxxxxx/
export function ajaxGetDetailByID (opt) {
    return ajax(opt,"GET2")
}

//websocket获取jwt请求token
export function getJWTAuthorization() {
    var token= getStorage('logintoken')
    var jwt = 'JWTlybbn' + token
    return jwt
}

export function reqExpost (method, url, params) {
  let token = getStorage('logintoken')
  for (let key in params){
    if(params[key]==null || params[key] == 'undefined' ||  params[key]==''){
      delete params[key]
    }
  }
  const keys = Object.keys(params).sort(); let i;
  const length = keys.length;
  let key;
  let sortedString = '';
  for (i = 0; i < length; i++) {
    key = keys[i];
    sortedString += (key + '=' + params[key]);
  }
  var config1={
    url: url,
    method: method,
    headers:{
        Authorization: 'JWT ' + token,
    },
    responseType: 'blob',
    params:params
  }
  return new Promise((resolve,reject)=>{
    request(config1).then(res=>{
        if(res.data.code==4001){
            ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                confirmButtonText:'确定',
                type: 'warning',
                callback: action => {
                    //跳转登录页   callback点击确定按钮后的回调函数
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href="/"
                }
            })
        }else{
            resolve(res.data)
        }
    }).catch(res=>{
        handleError(res);
        reject(res)
    })
})
}

export function download(url,param){
    let token = getStorage('logintoken')
    let httpDefaultOpts = {
        method: 'download',
        url: url,//接口的地址
        timeout: 60000,
        params: param,//下载文件请求接口的参数
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
            Authorization: 'JWT ' + token,
        }
      }
      httpDefaultOpts.responseType = 'blob'
      httpDefaultOpts.method = 'get'
    
    return new Promise((resolve,reject)=>{
        request(httpDefaultOpts).then(res=>{
            if(res.data.code==4001){
                ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                    confirmButtonText:'确定',
                    type: 'warning',
                    callback: action => {
                        //跳转登录页   callback点击确定按钮后的回调函数
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href="/"
                    }
                })
            }else{
                resolve(res.data)
            }
        }).catch(res=>{
            handleError(res);
            reject(res)
        })
    })
}
// 上传图片
export function uploadImg (param) {
    let formData = new FormData()
    formData.append('file', param.params.file)
    let token= getStorage('logintoken')
    return axios({
        method: 'post',
        url: param.url ,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'JWT ' + token,
        },
        data:formData,
        onUploadProgress: progressEvent => {
            // progressEvent.loaded:已上传文件大小
            // progressEvent.total:被上传文件的总大小
            let loadProgress = (progressEvent.loaded / progressEvent.total * 100)
            if(param.params.onProgress){
                param.params.onProgress({percent: loadProgress})
            }
          }
    }).then(res => res.data);
}
